export const STRINGS = {
  en: {
    nav: {
      treatments: "Treatments",
      therapist: "Your Therapist",
      credentials: "Credentials",
      booking: "Private Booking",
      requestSlot: "Request Slot",
    },
    hero: {
      badge: "Private Incall & Mobile Outcall — Houston",
      h1a: "Houston's",
      h1b: "Softest",
      h1c: "Secret.",
      sub: "Licensed massage therapy curated in a discreet, private setting or delivered to your doorstep with total professionalism.",
      tagline: "Bilingual — English & Español · Morning Appointments Available",
      book: "Book Private Session",
      whatsapp: "Discreet WhatsApp Enquiry",
      capL: "Licensed LMT Protocol",
      capR: "Premium & Hemp Oils",
    },
    marquee: [
      "Licensed Massage Therapist",
      "Complete Discretion",
      "Luxurious Outcall Service",
      "Se Habla Español",
      "Hot Oil & Nuru Rituals",
      "Morning Appointments",
      "Hot Towel Finishes",
      "Hemp Body Oil For Sale",
      "The Mocha Experience",
    ],
    services: {
      label: "The Menu",
      title: "Signature Repertoire",
      subtitle: "One menu, two ways to melt — pick your ritual, then pick your time. Every session begins with a brief consultation to calibrate pressure, warmth, and your comfort.",
      reserve: "Reserve →",
      menu: [
        {
          name: "The Mocha Melt",
          sub: "Hot Oil Full Body",
          desc: "Slow, rhythmic strokes with heated premium oils to dissolve deep-seated tension.",
          durations: [{ min: "60", price: "$145" }],
        },
        {
          name: "Hot Melted Butter Friction",
          tag: "Signature",
          desc: "The signature Velvet Touch ritual — warm, silky gel and long, gliding full-body strokes for deep, weightless relaxation.",
          durations: [
            { min: "45", price: "$140" },
            { min: "60", price: "$180" },
          ],
        },
        {
          name: "Dedicated Time & Extended Finish",
          desc: "Unhurried, dedicated time with a custom finish — tailored entirely to you in a discreet, private setting.",
          durations: [
            { min: "45", price: "$150" },
            { min: "60", price: "$215" },
          ],
        },
        {
          name: "THC-Infused Hemp Oil Massage",
          desc: "THC-infused hemp body oil worked deep into tired muscles for a calm that lingers.",
          durations: [{ min: "45", price: "$160" }],
        },
        {
          name: "Stone Massage",
          desc: "Heated stones and warm oil melt tension layer by layer.",
          durations: [{ min: "45", price: "$175" }],
        },
      ],
      notes: [
        { label: "Also On The Menu", text: "Deep Tissue / Therapeutic, Hemp Oil Massages & Hot Towel Finishes" },
        { label: "Outcall Policy", text: "One-way Uber/Lyft provided by client, or a $40–50 travel fee applies" },
        { label: "Good To Know", text: "Morning appointments available · Professional table & oils on hand" },
      ],
      hempTag: "Now Available",
      hemp: "Hemp Body Oil is for sale — add hot towels to any session for the full velvet finish.",
      hempBtn: "Ask On WhatsApp",
      merch: {
        label: "From Mocha's Shelf",
        name: "Hemp Body Oil",
        desc: "Mocha's own hemp-infused body oil — take the velvet finish home with you, or add it to any session.",
        priceNote: "Price on request · limited bottles each week",
        order: "Order On WhatsApp",
      },
    },
    exp: [
      { title: "Strict Discretion", text: "Private setting, confidential booking, and complete client privacy honored at all times." },
      { title: "Licensed Craft", text: "A licensed massage therapist (LMT) with trained hands, calm energy, and total professionalism." },
      { title: "Sensory Luxury", text: "Warm premium and hemp oils, soft light, and plush linen — a calm, luxurious experience from start to finish." },
    ],
    about: {
      label: "Your Therapist",
      meet: "Meet Mahogany",
      para: "Dominican-born and now based in Houston, Mahogany is a licensed massage therapist known for soft hands, good energy, and a relaxing experience tailored just for you — discreet, private, and professional from the first message to the final moment. Clients call her Mocha: warm, smooth, and never rushed.",
      quote: "“Hola, soy Mahogany — estoy en Houston para servirte. Se habla español.”",
      facts: [
        "Licensed Massage Therapist (LMT)",
        "Bilingual — English & Español",
        "Professional table & premium oils on hand",
        "Morning appointments available",
      ],
      capL: "Mahogany · LMT",
    },
    creds: {
      label: "Trust & Professionalism",
      title: "Licensed & Verified",
      para: "Every session is guided by professional standards, clear communication, and your comfort. Consent and peace of mind shape every touch.",
      list: [
        "Licensed Massage Therapist (LMT)",
        "Discreet, Private & Professional Setting",
        "Clean Health & Hygiene Standards",
      ],
      wordsTitle: "Client Words",
      review: {
        quote: "“You give the best massages I've ever had!! You will be the only person massaging my back! I'm going to spend thousands with you.”",
        attr: "— Verified client, real text message",
        proof: "The actual text, unedited",
        more: "More verified words coming soon",
      },
      review2: {
        quote: "“She fixed my lower back I thought was done for.”",
        attr: "— Verified client",
      },
    },
    faq: {
      label: "Good To Know",
      title: "Questions, Answered",
      items: [
        {
          q: "What is your deposit policy?",
          a: "A $25 deposit is required to book, and it's applied to your session total. Deposits are non-refundable for no-shows or cancellations inside 24 hours.",
        },
        {
          q: "What should I expect on my first visit?",
          a: "A brief consultation to calibrate pressure, warmth, and comfort before we begin.",
        },
        {
          q: "What is your cancellation policy?",
          a: "Cancel or reschedule at least 24 hours before your appointment for a full refund of your deposit. Inside 24 hours, the deposit is forfeited. Same-day no-shows are charged the full session rate.",
        },
        {
          q: "Do you offer outcall?",
          a: "Yes — one-way Uber or Lyft provided by the client, or a $40–50 travel fee applies. Outcall requires deposit plus travel fee paid upfront.",
        },
      ],
      payLabel: "Payments & Deposits",
      payText: "Deposits accepted via Venmo or Zelle for fastest confirmation. Session balance due in cash, Venmo, Zelle, or card at check-in.",
      venmoBtn: "Venmo @MahoganyD",
    },
    book: {
      label: "Private Booking & Inquiries",
      title: "Reserve Your Experience",
      sub: "Select your preferred session and time. For the fastest reply, call, text, or WhatsApp — Se habla español.",
      name: "Your Name",
      namePh: "Preferred name",
      contact: "Contact Method",
      contactPh: "Phone or email",
      emailLabel: "Email for Confirmation",
      emailPh: "you@email.com",
      screening: "Screening required — first-time clients, please mention how you found Velvet Touch.",
      giftLabel: "This is a gift for someone",
      treatment: "Desired Treatment",
      datetime: "Preferred Date & Time",
      where: "Incall or Outcall",
      incall: "Incall — Her Private Space",
      outcall: "Outcall — She Comes To You",
      outcallNote: "Outcalls: one-way Uber/Lyft provided by client, or a $40–50 travel fee applies.",
      notes: "Location & Special Requests",
      notesPh: "Incall preference, or your hotel/area for outcall...",
      submit: "Send Appointment Request",
      sending: "Sending…",
      direct: "Direct Instant Channels:",
      whatsapp: "WhatsApp Chat",
      call: "Tap to Call",
      options: [
        "The Mocha Melt (Hot Oil Full Body) — $145 (60 min)",
        "Hot Melted Butter Friction — $140 (45 min)",
        "Hot Melted Butter Friction — $180 (60 min)",
        "Extended Finish Massage — $150 (45 min)",
        "Dedicated Time & Custom Finish — $215 (60 min)",
        "THC-Infused Hemp Oil Massage — $160 (45 min)",
        "Stone Massage — $175 (45 min)",
        "Outcall / Mobile Session",
      ],
      toastOk: "Request received — Mahogany will confirm discreetly. You can also WhatsApp or call for a faster reply.",
      toastErr: "Something went wrong sending your request — please WhatsApp or call instead.",
    },
    footer: {
      rights: "Strictly Professional Bodywork · By Appointment Only · Se Habla Español",
      owner: "Owner Login",
    },
    gallery: {
      label: "The Velvet Gallery",
      title: "Behind the Velvet Touch",
      sub: "Real photos, real hands — no stock here, all Mocha.",
    },
    gift: {
      label: "Gift The Mocha Touch",
      title: "Treat Someone",
      text: "Prepay a session for a partner or friend — they book whenever they're ready, you take the credit.",
      cta: "Gift A Session",
    },
    admin: {
      privateArea: "Private Area",
      signIn: "Owner Sign In",
      email: "Email",
      emailPh: "you@email.com",
      password: "Password",
      openInbox: "Open My Inbox",
      signingIn: "Signing In…",
      logout: "Log Out",
      inboxTag: "Owner Inbox",
      listLabel: "Every Request, One List",
      listTitle: "Booking Requests",
      refresh: "Refresh",
      loading: "Loading…",
      empty: "No booking requests yet — share your link and they'll land here.",
      incall: "Incall",
      outcall: "Outcall",
      handled: "Handled",
      markHandled: "Mark Handled",
      undo: "Undo",
      del: "Delete",
      confirmDel: "Delete this request for good?",
      noTime: "No preferred time",
      welcome: "Welcome back, Mocha",
      tDeleted: "Request deleted",
      tHandled: "Marked as handled",
      tReopen: "Moved back to new",
      tFail: "Action failed — try again.",
      tLoadFail: "Could not load bookings — try again.",
      gifted: "Gifted",
    },
  },
  es: {
    nav: {
      treatments: "Tratamientos",
      therapist: "Tu Terapeuta",
      credentials: "Credenciales",
      booking: "Reserva Privada",
      requestSlot: "Reservar",
    },
    hero: {
      badge: "Incall Privado y Outcall a Domicilio — Houston",
      h1a: "El Secreto",
      h1b: "Más Suave",
      h1c: "de Houston.",
      sub: "Terapia de masaje licenciada en un entorno discreto y privado, o llevada directamente a tu puerta con total profesionalismo.",
      tagline: "Bilingüe — English & Español · Citas por la Mañana Disponibles",
      book: "¿Listo para Relajarte?",
      whatsapp: "Consulta Discreta por WhatsApp",
      capL: "Protocolo LMT Licenciada",
      capR: "Aceites Premium y de Cáñamo",
    },
    marquee: [
      "Terapeuta de Masaje Licenciada",
      "Discreción Total",
      "Servicio Outcall de Lujo",
      "Se Habla Español",
      "Rituales de Aceite Caliente y Nuru",
      "Citas por la Mañana",
      "Acabado con Toallas Calientes",
      "Aceite de Cáñamo a la Venta",
      "La Experiencia Mocha",
    ],
    services: {
      label: "El Menú",
      title: "Repertorio Insignia",
      subtitle: "Un solo menú, dos formas de rendirte — elige tu ritual, luego elige tu tiempo. Cada sesión comienza con una breve consulta para ajustar la presión, la calidez y tu comodidad.",
      reserve: "Reservar →",
      menu: [
        {
          name: "The Mocha Melt",
          sub: "Aceite Caliente Cuerpo Completo",
          desc: "Movimientos lentos y rítmicos con aceites premium calientes para disolver la tensión más profunda.",
          durations: [{ min: "60", price: "$145" }],
        },
        {
          name: "Hot Melted Butter Friction",
          tag: "Insignia",
          desc: "El ritual insignia de Velvet Touch — gel tibio y sedoso con largos movimientos envolventes para una relajación profunda y ligera.",
          durations: [
            { min: "45", price: "$140" },
            { min: "60", price: "$180" },
          ],
        },
        {
          name: "Tiempo Dedicado & Acabado Extendido",
          desc: "Tiempo dedicado y sin prisas con un acabado personalizado — hecho a tu medida en un entorno discreto y privado.",
          durations: [
            { min: "45", price: "$150" },
            { min: "60", price: "$215" },
          ],
        },
        {
          name: "Masaje con Aceite de Cáñamo THC",
          desc: "Aceite de cáñamo con THC trabajado profundo en músculos cansados para una calma que perdura.",
          durations: [{ min: "45", price: "$160" }],
        },
        {
          name: "Masaje con Piedras",
          desc: "Piedras calientes y aceite tibio derriten la tensión capa por capa.",
          durations: [{ min: "45", price: "$175" }],
        },
      ],
      notes: [
        { label: "También en el Menú", text: "Tejido Profundo / Terapéutico, Masajes con Cáñamo y Toallas Calientes" },
        { label: "Política de Outcall", text: "Uber/Lyft de ida proporcionado por el cliente, o una tarifa de viaje de $40–50" },
        { label: "Bueno Saber", text: "Citas por la mañana disponibles · Mesa profesional y aceites a la mano" },
      ],
      hempTag: "Ya Disponible",
      hemp: "El Aceite de Cáñamo está a la venta — añade toallas calientes a cualquier sesión para el acabado velvet perfecto.",
      hempBtn: "Preguntar por WhatsApp",
      merch: {
        label: "De la Repisa de Mocha",
        name: "Aceite Corporal de Cáñamo",
        desc: "El aceite corporal de cáñamo de Mocha — llévate el acabado velvet a casa, o añádelo a cualquier sesión.",
        priceNote: "Precio a consultar · pocas botellas cada semana",
        order: "Pedir por WhatsApp",
      },
    },
    exp: [
      { title: "Discreción Estricta", text: "Entorno privado, reservas confidenciales y total privacidad del cliente en todo momento." },
      { title: "Oficio Licenciado", text: "Una terapeuta de masaje licenciada (LMT) con manos entrenadas, energía tranquila y total profesionalismo." },
      { title: "Lujo Sensorial", text: "Aceites premium y de cáñamo tibios, luz suave y sábanas de lujo — una experiencia calmada y lujosa de principio a fin." },
    ],
    about: {
      label: "Tu Terapeuta",
      meet: "Conoce a Mahogany",
      para: "Dominicana y ahora establecida en Houston, Mahogany es una terapeuta de masaje licenciada conocida por sus manos suaves, buena energía y una experiencia relajante hecha solo para ti — discreta, privada y profesional desde el primer mensaje hasta el último momento. Sus clientes la llaman Mocha: cálida, suave y sin prisas.",
      quote: "“Hola, soy Mahogany — estoy en Houston para servirte. Se habla español.”",
      facts: [
        "Terapeuta de Masaje Licenciada (LMT)",
        "Bilingüe — English & Español",
        "Mesa profesional y aceites premium a la mano",
        "Citas por la mañana disponibles",
      ],
      capL: "Mahogany · LMT",
    },
    creds: {
      label: "Confianza y Profesionalismo",
      title: "Licenciada y Verificada",
      para: "Cada sesión se guía por estándares profesionales, comunicación clara y tu comodidad. El consentimiento y tu tranquilidad guían cada toque.",
      list: [
        "Terapeuta de Masaje Licenciada (LMT)",
        "Entorno Discreto, Privado y Profesional",
        "Estándares de Salud e Higiene Impecables",
      ],
      wordsTitle: "Palabras de Clientes",
      review: {
        quote: "“¡Das los mejores masajes que he tenido! ¡Serás la única persona que masajee mi espalda! Voy a gastar miles contigo.”",
        attr: "— Cliente verificado, mensaje de texto real",
        proof: "El texto real, sin editar",
        more: "Más palabras verificadas pronto",
      },
      review2: {
        quote: "“Me arregló la espalda baja que creí perdida.”",
        attr: "— Cliente verificado",
      },
    },
    faq: {
      label: "Bueno Saber",
      title: "Preguntas, Respondidas",
      items: [
        {
          q: "¿Cuál es tu política de depósito?",
          a: "Se requiere un depósito de $25 para reservar, aplicado al total de tu sesión. Los depósitos no son reembolsables por no presentarse o cancelaciones dentro de 24 horas.",
        },
        {
          q: "¿Qué debo esperar en mi primera visita?",
          a: "Una breve consulta para ajustar la presión, la calidez y tu comodidad antes de comenzar.",
        },
        {
          q: "¿Cuál es tu política de cancelación?",
          a: "Cancela o reprograma al menos 24 horas antes de tu cita para un reembolso completo del depósito. Dentro de 24 horas, el depósito se pierde. No presentarse el mismo día se cobra la tarifa completa de la sesión.",
        },
        {
          q: "¿Ofreces outcall?",
          a: "Sí — Uber o Lyft de ida proporcionado por el cliente, o una tarifa de viaje de $40–50. Outcall requiere depósito más tarifa de viaje pagados por adelantado.",
        },
      ],
      payLabel: "Pagos y Depósitos",
      payText: "Depósitos aceptados por Venmo o Zelle para confirmación rápida. El resto se paga en efectivo, Venmo, Zelle o tarjeta al llegar.",
      venmoBtn: "Venmo @MahoganyD",
    },
    book: {
      label: "Reserva Privada y Consultas",
      title: "Reserva Tu Experiencia",
      sub: "Elige tu sesión y horario preferido. Para respuesta rápida, llama, envía texto o escribe por WhatsApp.",
      name: "Tu Nombre",
      namePh: "Nombre preferido",
      contact: "Método de Contacto",
      contactPh: "Teléfono o correo",
      emailLabel: "Correo para Confirmación",
      emailPh: "tu@correo.com",
      screening: "Se requiere verificación — clientes nuevos, menciona cómo encontraste Velvet Touch.",
      giftLabel: "Es un regalo para alguien",
      treatment: "Tratamiento Deseado",
      datetime: "Fecha y Hora Preferida",
      where: "¿Incall u Outcall?",
      incall: "Incall — Su Espacio Privado",
      outcall: "Outcall — Ella Va a Ti",
      outcallNote: "Outcalls: Uber/Lyft de ida proporcionado por el cliente, o una tarifa de viaje de $40–50.",
      notes: "Ubicación y Peticiones Especiales",
      notesPh: "Preferencia de incall, o tu hotel/zona para outcall...",
      submit: "Enviar Solicitud de Cita",
      sending: "Enviando…",
      direct: "Canales Directos:",
      whatsapp: "Chat de WhatsApp",
      call: "Llamar",
      options: [
        "The Mocha Melt (Aceite Caliente) — $145 (60 min)",
        "Hot Melted Butter Friction — $140 (45 min)",
        "Hot Melted Butter Friction — $180 (60 min)",
        "Masaje con Acabado Extendido — $150 (45 min)",
        "Tiempo Dedicado & Acabado Personalizado — $215 (60 min)",
        "Masaje con Aceite de Cáñamo THC — $160 (45 min)",
        "Masaje con Piedras — $175 (45 min)",
        "Sesión Outcall / A Domicilio",
      ],
      toastOk: "Solicitud recibida — Mahogany confirmará discretamente. También puedes escribir por WhatsApp o llamar para respuesta rápida.",
      toastErr: "Algo salió mal al enviar — por favor escribe por WhatsApp o llama.",
    },
    footer: {
      rights: "Masaje Estrictamente Profesional · Solo con Cita · Se Habla Español",
      owner: "Acceso Dueña",
    },
    gallery: {
      label: "La Galería Velvet",
      title: "Detrás del Velvet Touch",
      sub: "Fotos reales, manos reales — nada de stock, todo Mocha.",
    },
    gift: {
      label: "Regala el Toque Mocha",
      title: "Consiente a Alguien",
      text: "Prepaga una sesión para tu pareja o un amigo — ellos reservan cuando estén listos, tú te llevas el crédito.",
      cta: "Regalar una Sesión",
    },
    admin: {
      privateArea: "Área Privada",
      signIn: "Acceso de la Dueña",
      email: "Correo",
      emailPh: "tu@correo.com",
      password: "Contraseña",
      openInbox: "Abrir Mi Buzón",
      signingIn: "Entrando…",
      logout: "Cerrar Sesión",
      inboxTag: "Buzón de la Dueña",
      listLabel: "Cada Solicitud, Una Lista",
      listTitle: "Solicitudes de Reserva",
      refresh: "Actualizar",
      loading: "Cargando…",
      empty: "Aún no hay solicitudes — comparte tu enlace y caerán aquí.",
      incall: "Incall",
      outcall: "Outcall",
      handled: "Atendida",
      markHandled: "Marcar Atendida",
      undo: "Deshacer",
      del: "Eliminar",
      confirmDel: "¿Eliminar esta solicitud para siempre?",
      noTime: "Sin horario preferido",
      welcome: "Bienvenida, Mocha",
      tDeleted: "Solicitud eliminada",
      tHandled: "Marcada como atendida",
      tReopen: "De vuelta a nuevas",
      tFail: "La acción falló — intenta de nuevo.",
      tLoadFail: "No se pudieron cargar las reservas — intenta de nuevo.",
      gifted: "Regalada",
    },
  },
};
